import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Typography from "@mui/material/Typography";
import "./User_Individual.css";
export const UserProfileIndividual = () => {
  const { userId } = useParams();
  const [userProfile, setUserProfile] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getUserProfile = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/userinfo/indi/${userId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setUserProfile(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserProfile();
  }, [userId]);

  if (!userProfile) {
    return <div>Loading...</div>;
  }
  return (
    <div className="box">
      <Typography
        className="questrial"
        variant="h4"
        style={{ marginBottom: "1.5rem" }}
      >
        User Profile Details
      </Typography>
      <div
        className="questrial"
        style={{ display: "flex", flexDirection: "column", gap: "8px" }}
      >
        <p className="questrial">
          <strong>ID:</strong> {userProfile._id}
        </p>
        <p className="questrial">
          <strong>Name:</strong> {userProfile.name}
        </p>
        <p className="questrial">
          <strong>Email:</strong> {userProfile.email}
        </p>
        <p className="questrial">
          <strong>Type:</strong> {userProfile.type}
        </p>
        <p className="questrial">
          <strong>Is Google Signup:</strong>{" "}
          {userProfile.isGoogleSignup.toString()}
        </p>
      </div>
      {/* Add more details based on your user profile data */}
    </div>
  );
};
